<app-dashboard-content
  [dashboardData]="dashboardData"
  [isDevicesLastActiveSummaryDataLoading]="isDevicesLastActiveSummaryDataLoading"
  [isDevicesAueSummaryDataLoading]="isDevicesAueSummaryDataLoading"
  [isDevicesVersionSummaryDataLoading]="isDevicesVersionSummaryDataLoading"
  [isDevicesBatteryHealthSummaryDataLoading]="isDevicesBatteryHealthSummaryDataLoading"
  [deviceSearchFilterBarId]="deviceSearchFilterBarId"
  [selectedFilters$]="selectedFilters$"
  [currentFilters]="currentFilters"
  [actionTrigger]="chartActionTrigger"
  (cardAction)="onActionClick($event)"
  (aggregateReportSelect)="onAggregateReportSelect($event)"
  (filtersChange)="onDashboardFiltersChanged($event)"
></app-dashboard-content>
